import { render, staticRenderFns } from "./VirtualVisitEmailSettings.vue?vue&type=template&id=43f09950&scoped=true&"
import script from "./VirtualVisitEmailSettings.vue?vue&type=script&lang=js&"
export * from "./VirtualVisitEmailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f09950",
  null
  
)

export default component.exports